import type { ReactNode } from "react";

export function Card({
  children,
  className = "",
  id,
}: {
  children: ReactNode;
  className?: string;
  id?: string; // 編集フォームへスクロールさせる等、アンカーが必要な箇所で使う
}) {
  return (
    <div
      id={id}
      className={`bg-white ring-1 ring-ink/10 shadow-[0_1px_0_rgba(10,10,10,0.04)] ${className}`}
    >
      {children}
    </div>
  );
}
